import React from 'react'
import { Link } from 'react-router-dom'

// mui
import { ListItem, ListItemText, Divider, IconButton } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

const CardListItem = ({ title, subtitle, linkPath }) => {

    return (<>
        <ListItem
            secondaryAction={
                linkPath && <Link to={linkPath} component={IconButton}><ChevronRightIcon /></Link>
            }
        >
            <ListItemText 
                primary={title}
                secondary={subtitle ? subtitle : null}
            />
        </ListItem>
        <Divider />
    </>)
}

export default CardListItem